import request from '@/router/axios'

/**
 * 根据字典类型获取字典列表
 * @author Shawn Fenng
 * @Date 2019-11-05
 * @param arguments
 */
export function getDictDataByType(dictType) {
  return request({
    url: "/api/business/portal/dictdata/" + dictType,
    method: "get"
  })
}